// extracted by mini-css-extract-plugin
export var button = "_ov-1";
export var container = "_ov-0";